import puntozero from '../images/puntozero.png';
import '../App.css';

function Puntozero () {
    return (
        <img className="Puntozero" src={puntozero} alt="cassapancapuntozero"/>
    )
}

export default Puntozero;

